import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import {
  additionalCostData,
  btnColor,
  btnDisabledFlg,
  mainBlueColor,
  progressFlgState,
  workingBudgetData,
  workingBudgetInfo,
  workingBudgetVendor
} from '../../GlobalState';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableContainer
} from '@material-ui/core';
import { ItemTableHeader } from './ItemTableHeader';
import { AdditionalCostItemTableBody } from './AdditionalCostItemTableBody';
import _ from 'lodash';
import { TypeRow, TypeWorkingBudgetInfo } from '../../types/WorkingBudgetPage';
import {
  addWorkingBudgetSelectAdditionalCost,
  deleteWorkingBudgetSelectAdditionalCost,
  updateTotallingInfo
} from '../../apicalls/WorkingBudgetPage';
import {
  deleteWorkingBudgetSelectAdditionalCostData,
  getReturnWorkingBudgetData,
  getWorkingBudgetData,
  recalculation,
  setDrawingData,
  updateWorkingBudgetData
} from '../../utils/WorkingBudgetPage';
import { NOT_LOGGED_IN } from '../../const/Const';

const StyledTable = withStyles(theme => ({
  root: {
    padding: '0px !important'
  }
}))(Table);

type Tprops = {
  isDetailShow: boolean;
  changeLoggedInData: (newData: string) => void;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSuccessMessage: React.Dispatch<React.SetStateAction<string>>;
  setOpenSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  workingBudgetId: number;
  reflectData: boolean;
};

/**
 * 追加原価
 * @constructor
 */
export const AdditionalCost: React.FC<Tprops> = (props: Tprops) => {
  const {
    isDetailShow,
    changeLoggedInData,
    setErrorMessage,
    setOpen,
    setSuccessMessage,
    setOpenSuccess,
    workingBudgetId,
    reflectData
  } = props;

  const [buttonColor] = useRecoilState(btnColor);
  const classes = useStyles({ buttonColor: buttonColor });
  const [additionalCost, setAdditionalCost] =
    useRecoilState(additionalCostData);
  const [workingBudget, setWorkingBudget] = useRecoilState(workingBudgetData);
  const [vendor, setVendor] = useRecoilState(workingBudgetVendor);
  const [totallingInfo, setTotallingInfo] = useRecoilState(workingBudgetInfo);
  const [selectItems, setSelectItems] = useState<number[]>([]);
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  const [disabledFlg] = useRecoilState(btnDisabledFlg);

  const addRow = () => {
    setProgressFlg(true);
    const cloneAdditionalCost: TypeRow[] = additionalCost
      ? _.cloneDeep(additionalCost)
      : [];
    let row: TypeRow = {
      name: '',
      detail: '',
      quantity: 0,
      unit_name: '',
      cost_quantity: 0,
      cost_unit_name: '',
      cost_unit_price: 0,
      cost_price: 0,
      vendor_order_price: []
    };

    addWorkingBudgetSelectAdditionalCost(row, workingBudgetId)
      .then(data => {
        if (data.data === NOT_LOGGED_IN) {
          changeLoggedInData(NOT_LOGGED_IN);
        } else {
          row.id = data.data;
          cloneAdditionalCost.push(row);
          setAdditionalCost(cloneAdditionalCost);
        }
      })
      .finally(() => setProgressFlg(false));
  };

  const deleteRow = () => {
    setProgressFlg(true);
    if (workingBudget) {
      // 一旦保存
      updateWorkingBudgetData(
        workingBudget,
        additionalCost,
        vendor,
        totallingInfo,
        workingBudgetId,
        changeLoggedInData,
        setErrorMessage,
        setOpen,
        setSuccessMessage,
        setOpenSuccess,
        setWorkingBudget,
        setVendor,
        setAdditionalCost,
        true
      )
        .then(async (returnData: any) => {
          let resAdditionalCost: TypeRow[] = returnData.data.additional_costs;
          const deleteItems: TypeRow[] = [];
          selectItems.map(selectid => {
            const deleteItem = resAdditionalCost.find(
              item => item.id == selectid
            );
            deleteItem && deleteItems.push(deleteItem);
          });

          setSelectItems([]);

          if (deleteItems.length > 0 && totallingInfo) {
            // 行を削除
            return await deleteWorkingBudgetSelectAdditionalCostData(
              deleteItems,
              workingBudgetId,
              changeLoggedInData,
              totallingInfo,
              setWorkingBudget,
              setVendor,
              setAdditionalCost,
              setOpenSuccess,
              setSuccessMessage
            );
          }
        })
        .finally(() => setProgressFlg(false));
    }
  };

  return (
    <div className={classes.container}>
      <TableContainer component={Paper} style={{ height: '600px' }}>
        <StyledTable
          stickyHeader
          className={classes.table}
          aria-label='sticky table'
          style={{ tableLayout: 'fixed' }}
        >
          <ItemTableHeader
            isDetailShow={isDetailShow}
            mode={1}
            setSelectItems={setSelectItems}
          />
          <TableBody>
            <AdditionalCostItemTableBody
              isDetailShow={isDetailShow}
              selectItems={selectItems}
              setSelectItems={setSelectItems}
              changeLoggedInData={changeLoggedInData}
              setErrorMessage={setErrorMessage}
              setOpen={setOpen}
              workingBudgetId={workingBudgetId}
              reflectData={reflectData}
            />
          </TableBody>
        </StyledTable>
      </TableContainer>

      <div className={classes.btnArea}>
        <div className={classes.right}>
          <Button
            style={{ backgroundColor: buttonColor }}
            variant='contained'
            color='primary'
            onClick={addRow}
            disabled={disabledFlg}
          >
            行追加
          </Button>
          <Button
            className={classes.redBtn}
            variant='contained'
            color='primary'
            onClick={deleteRow}
            disabled={!(selectItems && selectItems.length > 0)}
          >
            選択行を削除
          </Button>
        </div>
      </div>
    </div>
  );
};

type TStyleProps = {
  buttonColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
      padding: 10
    },
    btnArea: {
      padding: 20,
      display: 'flex',
      width: '100%'
    },
    right: {
      display: 'flex',
      width: '100%',
      gap: 20,
      justifyContent: 'flex-end'
    },
    redBtn: {
      backgroundColor: '#ff1212',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#ff4444',
        boxShadow: 3
      }
    }
  })
);
